export enum SidenavMenuMode {
    Favorites = 'favorites',
    All = 'all'
}
